import { render } from "./input_primary.vue?vue&type=template&id=ab141584&scoped=true"
import script from "./input_primary.vue?vue&type=script&lang=js"
export * from "./input_primary.vue?vue&type=script&lang=js"

import "./input_primary.vue?vue&type=style&index=0&id=ab141584&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab141584"]])

export default __exports__